import { HStack, VStack } from '@genial/components';
import React from 'react';

import {
  StatusSkeleton,
  TextSkeleton,
} from '../../../../../../../BatchTicket/components/DynamicAsset/components/AssetsLoading';

export const FixedFeeRelatedTermLoadingDesktop: React.FC = () => {
  return (
    <HStack
      p="inset.xs"
      backgroundColor="backgroundshade"
      justifyContent="space-between"
      borderBottomRadius="sm">
      <VStack space="stack.quarck" flex={1}>
        <TextSkeleton w="30%" h="12px" />
        <TextSkeleton w="45%" />
        <StatusSkeleton w="35%" />
      </VStack>

      <VStack space="stack.quarck" alignItems="flex-end" minW="120px">
        <TextSkeleton w="50%" h="12px" />
        <TextSkeleton w="70%" />
      </VStack>
    </HStack>
  );
};
